import { render, staticRenderFns } from "./indexPreview.vue?vue&type=template&id=022389e7&scoped=true&"
import script from "./indexPreview.vue?vue&type=script&lang=js&"
export * from "./indexPreview.vue?vue&type=script&lang=js&"
import style0 from "./indexPreview.vue?vue&type=style&index=0&id=022389e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022389e7",
  null
  
)

export default component.exports